'use strict'

export const unrektApi = (async () => {
  return fetch('https://api.unrekt.net/api/v2/acryptos-asset')
    .then((response) => response.json())
})()
